const timelineInit = () => {
	const timelines = document.querySelectorAll('.bn-timeline__items');

	timelines.forEach((timeline) => {
		const items = Array.from(timeline.querySelectorAll(':scope > .bn-timeline__item'));

		// Always reset margins first.
		items.forEach((item) => {
			item.style.marginTop = '';
		});

		// Apply negative margin only on screens wider than 768px.
		if (window.innerWidth <= 768) {
			return;
		}

		// Track the CSS flow position and the visual bottom of each side (left/right).
		let flowTop = 0;
		const sideBottom = [0, 0];

		items.forEach((item, index) => {
			const side = index % 2; // 0 = left, 1 = right
			const height = item.offsetHeight;

			// Pull this item up by half the previous item's height if it was tall.
			const prevItem = items[index - 1];
			const desiredPull = (prevItem && prevItem.offsetHeight > 300)
				? Math.round(prevItem.offsetHeight / 2)
				: 0;

			let effectiveTop = flowTop - desiredPull;

			// Clamp: never go above the bottom of the last item on the same side.
			if (effectiveTop < sideBottom[side]) {
				effectiveTop = sideBottom[side];
			}

			const margin = effectiveTop - flowTop;
			if (margin < 0) {
				item.style.marginTop = `${margin}px`;
			}

			// Advance tracking.
			flowTop = effectiveTop + height;
			sideBottom[side] = effectiveTop + height;
		});
	});
};

// Run after full page load (images included, so heights are accurate).
window.addEventListener('load', timelineInit);

// Re-run on resize so it stays accurate when viewport changes.
window.addEventListener('resize', timelineInit);
